import { isOkMinimumRevetmentThickness, isOkMinimumRevetmentWidthBProtection, isOkUnderKeelClearance } from '../conversion/result';
import i18n from '../localization';
import { IResult } from '../shared/iResult';
import { redux } from '../store';
import { setAlert } from '../store/alert/alertSlice';

const findIndicesByError = (array: any[] | undefined, fieldToCheck: string): number[] => {
    if (!array) {
        return [];
    }
    return array
        .map((x, i) => ({ x, i }))
        .filter(({ x }) => {
            if (Object.values(x).some(y => y !== null && y !== false)) return !x[fieldToCheck];
        })
        .map(({ i }) => i);
};

const validationAlertOutput = (output: IResult) => {
    let error = [];
    let indexScenarioError = [];
    let indexScenarioUKCerror = findIndicesByError(output.flowVelocityAtThePropellers, isOkUnderKeelClearance);
    if (indexScenarioUKCerror.length > 0) {
        error.push(i18n.t('underKeelClearanceNotValid'));
        indexScenarioError.push(...indexScenarioUKCerror);
    }

    let indexScenarioWidthOftheProtectionerror = findIndicesByError(output.propellerAxisParallelToTheQuayStructureScenarios, isOkMinimumRevetmentWidthBProtection);
    if (indexScenarioWidthOftheProtectionerror.length > 0) {
        error.push(i18n.t('minimumRevetmentWidthNotValid'));
        indexScenarioError.push(...indexScenarioWidthOftheProtectionerror);
    }

    let indexScenarioThicknessParallelToTheQuayError = findIndicesByError(output.propellerAxisParallelToTheQuayStructureScenarios, isOkMinimumRevetmentThickness);
    let indexScenarioThicknessTransverseToVerticalQuayError = findIndicesByError(output.propellerAxisTransverseToVerticalQuayStructureScenarios, isOkMinimumRevetmentThickness);
    let indexScenarioThicknessTransverseToSlopedQuayError = findIndicesByError(output.propellerAxisTransverseToSlopedQuayStructureScenarios, isOkMinimumRevetmentThickness);
    let indexScenarioThicknessOpenPiledQuayError = findIndicesByError(output.openPiledQuayScenarios, isOkMinimumRevetmentThickness!);
    if (
        indexScenarioThicknessParallelToTheQuayError.length > 0 ||
        indexScenarioThicknessTransverseToVerticalQuayError.length > 0 ||
        indexScenarioThicknessTransverseToSlopedQuayError.length > 0 ||
        indexScenarioThicknessOpenPiledQuayError.length > 0
    ) {
        error.push(i18n.t('minimumRevetmentThicknessNotValid'));
        indexScenarioError.push(
            ...indexScenarioThicknessParallelToTheQuayError,
            ...indexScenarioThicknessTransverseToVerticalQuayError,
            ...indexScenarioThicknessTransverseToSlopedQuayError,
            ...indexScenarioThicknessOpenPiledQuayError,
        );
    }

    if (error.length > 0) {
        let errorMessage = error.join(', ');
        redux.dispatch(setAlert({ title: errorMessage, indexScenarioError: [...new Set(indexScenarioError)] }));
    }
};

export default validationAlertOutput;
